angular.module('main').directive('btnClose', () => ({
	restrict: 'AE',
	scope: {},
	template:
		'<button type="button" class="close" data-dismiss="modal" aria-hidden="true" data-autotest-button="close">&times;</button>',
	replace: true,
	transclude: true
}));



// WEBPACK FOOTER //
// ./web/js/components/Buttons/btnClose.js